import Modal from "react-bootstrap/Modal";
import { Row, Col } from "react-bootstrap";
import _ from "lodash";
import * as paymentSelectors from "../../../../selectors/payment";
import LoadingOverlay from "../../../../components/LoadingOverlay";
import WithdrawComponentItem from "../../../EWithdraw/components/WithdrawComponentItem";
import clsx from "clsx";
import constants from "../../../../constants";
import CustomEmptyFont from "../../../../components/CustomEmptyFont";
import {getPaymentDetailAction, getPaymentManualPaymentItems} from "../../../../selectors/payment";
import DepositManualPaymentItem from "../../../EDeposit/components/DepositManualPaymentItem";
import DepositOnlinePaymentItem from "../../../EDeposit/components/DepositOnlinePaymentItem";
import * as eWithdrawSelectors from "../../../../selectors/e-withdraw";
import { getEWithdrawMetaDataCancelLink, getEWithdrawMetaDataIsCancellable } from "../../../../selectors/e-withdraw";
import PaymentContractsItem from "../../../EPayment/components/PaymentContractsItem";
function PaymentHistoryDetailModal({ show, handleClose, data, loading, onClickViewDocument, onClickDeleteFunction }) {
  const action = paymentSelectors.getPaymentDetailAction(data);
  const type = paymentSelectors.getPaymentDetailTypeText(data);
  const reference = paymentSelectors.getPaymentDetailReference(data);
  const depositAmount = paymentSelectors.getPaymentDetailDepositAmountFullText(data);
  const paymentAmount = paymentSelectors.getPaymentDetailPaymentAmountFullText(data);
  const totalAmount = paymentSelectors.getPaymentDetailTotalFullText(data);
  const clientRemarks = paymentSelectors.getPaymentDetailClientRemarks(data);
  const statusText = paymentSelectors.getPaymentDetailStatusText(data);
  const contracts = paymentSelectors.getPaymentDetailContracts(data);
  const statusValue = paymentSelectors.getPaymentDetailStatusValue(data);
  const id = paymentSelectors.getPaymentDetailID(data);
  const clientCode = paymentSelectors.getPaymentDetailClientCode(data);
  const createdAt = paymentSelectors.getPaymentDetailCreatedAtText(data);
  const additionalCharges = paymentSelectors.getPaymentDetailAdditionalCharges(data);

  const manualPaymentItems = paymentSelectors.getPaymentManualPaymentItems(data);
  const onlinePaymentItems = paymentSelectors.getPaymentOnlinePaymentItems(data);

  const isCancellable = eWithdrawSelectors.getEWithdrawMetaDataIsCancellable(data);
  const cancelLink = eWithdrawSelectors.getEWithdrawMetaDataCancelLink(data);

  const onClickDelete = (url) => {
    onClickDeleteFunction(url);
  };

  return (
    <Modal show={show} size="xl" onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title className={"annoucement-modal-title"}>Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/*key={index}*/}
        <Row>
          <Col md={6} xs={12}>
            <p>Type: {type}</p>
          </Col>
          <Col md={6} xs={12}>
            <p>Reference Number: {reference}</p>
          </Col>
          <Col md={6} xs={12}>
            <p>Client Code: {clientCode}</p>
          </Col>
          <Col md={6} xs={12}>
            <p>
              Status:{" "}
              <span
                className={clsx("status-span ", {
                  ["pending-color"]: _.isEqual(constants.STATUS_PAYMENT_PENDING, statusValue),
                  ["successful-color"]:
                  _.isEqual(constants.STATUS_PAYMENT_PAYMENT_MADE, statusValue) ||
                  _.isEqual(constants.STATUS_PAYMENT_APPROVED, statusValue),
                  ["error-color"]:
                  _.isEqual(constants.STATUS_PAYMENT_CANCELLED, statusValue) ||
                  _.isEqual(constants.STATUS_PAYMENT_ERROR, statusValue) ||
                  _.isEqual(constants.STATUS_PAYMENT_REJECTED, statusValue),
                })}
              >
                {statusText}
              </span>
            </p>
          </Col>
          {
            action === 'PAYMENT' ? (
                <Col md={6} xs={12}>
                  <p>
                    Total Payment Amount: <span>{paymentAmount}</span>
                  </p>
                </Col>
            ) : false
          }
          {
            action === 'PAYMENT' ? (
                <Col md={6} xs={12}>
                  <p>
                    Total Deposit Amount: <span>{depositAmount}</span>
                  </p>
                </Col>
            ) : false
          }
          {
            action === 'PAYMENT' ? (
                <Col md={12}>
                  <p>
                    Total Amount: <span>{totalAmount}</span>
                  </p>
                </Col>
            ) : false
          }
          {
            action === 'DEPOSIT' ? (
                <Col md={12}>
                  <p>
                    Total Deposit Amount: <span>{totalAmount}</span>
                  </p>
                </Col>
            ) : false
          }
          <Col md={12}>
            <p>
              <span>Client Remark:</span> <CustomEmptyFont variant="span" value={clientRemarks} />
            </p>
          </Col>
        </Row>
        {!_.isEmpty(contracts) ? <PaymentContractsItem data={contracts} ></PaymentContractsItem>:false}

        {manualPaymentItems
          ? _.map(manualPaymentItems, (item, index) => {
            return (
              <DepositManualPaymentItem
                key={index}
                onClickViewDocument={onClickViewDocument}
                item={item}
                index={index}
              />
            );
          })
          : false}
        {onlinePaymentItems ? <DepositOnlinePaymentItem item={onlinePaymentItems} /> : false}
        <div className="d-flex justify-content-end my-3 mr-3">

          <button className={clsx("btn custom-button-back")}  onClick={(e)=>{
            e.preventDefault()
            handleClose()
          }}>
            Close
          </button>
          {isCancellable ? <button
            className={clsx("btn custom-button-white")}
            onClick={(e)=>{
              e.preventDefault()
              onClickDelete(cancelLink)
            }}
            // disabled={!isCancellable}
          >
            Cancel
          </button>:false}
        </div>
        <LoadingOverlay loading={loading}></LoadingOverlay>
      </Modal.Body>
    </Modal>
  );
}

export default PaymentHistoryDetailModal;
